/* eslint-disable no-useless-escape */

/* eslint-disable no-control-regex */

/*
 * @Description:
 * @Author: suzyli
 * @Date: 2020-03-27 11:23:23
 * @LastEditTime: 2020-08-28 14:26:41
 */
// ==== xss Xss安全过滤相关
var xss = {
  /**
     * 通用过滤，对所有涉及到XSS漏洞的敏感字符和符号进行过滤
     * @param {oriStr} string 待过滤的原始字符串
     * @return {string} 过滤后的字符串
     */
  filter: function filter(oriStr) {
    if (!oriStr) {
      return oriStr;
    }

    var charCodes = ['3c', '3e', '27', '22', '28', '29', '60', {
      format: 'script{}',
      chr: '3a'
    }]; // 要转义字符的16进制ASCII码[1<  2>  3'  4"  5(  6)  7`]

    var xssChars = [];
    var filterChars = [];
    var tmpFormat = '{}';
    var tmpChr;

    for (var i = 0; i < charCodes.length; i++) {
      if ('string' === typeof charCodes[i]) {
        tmpFormat = '{}';
        tmpChr = charCodes[i];
      } else {
        tmpFormat = charCodes[i].format;
        tmpChr = charCodes[i].chr;
      }

      xssChars.push(tmpFormat.replace('{}', "\\u00".concat(tmpChr)));
      xssChars.push(tmpFormat.replace('{}', "%".concat(tmpChr))); // 1次encode

      xssChars.push(tmpFormat.replace('{}', "%25".concat(tmpChr))); // 2次encode

      filterChars.push(tmpFormat.replace('{}', "&#x".concat(tmpChr, ";")));
      filterChars.push(tmpFormat.replace('{}', "%26%23x".concat(tmpChr, "%3B"))); // 1次encode

      filterChars.push(tmpFormat.replace('{}', "%2526%2523x".concat(tmpChr, "%253B"))); // 2次encode
    }

    for (var _i = 0; _i < xssChars.length; _i++) {
      oriStr = oriStr.replace(new RegExp(xssChars[_i], 'gi'), filterChars[_i]);
    } // 预防script:
    // eslint-disable-next-line no-useless-escape


    oriStr = oriStr.replace(/script[\u000d\u000a\u0020]+\:/i, 'script&#x3a;');
    return oriStr;
  },

  /**
     * [专门过滤]过滤微信昵称，过滤除emoji表情之外的所有字符
     * @param {oriStr} string 待过滤的原始字符串
     * @return {string} 过滤后的字符串
     */
  filterWxNickName: function filterWxNickName(oriStr) {
    // console.log(this);
    var matchArr = oriStr.match(/\<span\sclass\=\"emoji\semoji[0-9a-z]+\"\>\<\/span\>/g);
    var oriTagStr = '';
    var filterTagStr = '';
    var tag = "{tag_".concat(new Date().getTime(), "}");

    if (!matchArr || !matchArr.length) {
      return this.filter(oriStr);
    }

    oriTagStr = oriStr.replace(/\<span\sclass\=\"emoji\semoji[0-9a-z]+\"\>\<\/span\>/g, tag);
    filterTagStr = this.filter(oriTagStr);

    for (var i = 0; i < matchArr.length; i++) {
      filterTagStr = filterTagStr.replace(tag, matchArr[i]);
    }

    return filterTagStr;
  }
};
export default xss;